module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "offset-md2": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-list-item-title', {
    staticClass: "headline mb-1"
  }, [_vm._v("Cuadre de Caja")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Total del Cheque"
    },
    model: {
      value: (_vm.vcheque),
      callback: function($$v) {
        _vm.vcheque = $$v
      },
      expression: "vcheque"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pt-100": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 200"
    },
    model: {
      value: (_vm.v200),
      callback: function($$v) {
        _vm.v200 = $$v
      },
      expression: "v200"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pt-100": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 100"
    },
    model: {
      value: (_vm.v100),
      callback: function($$v) {
        _vm.v100 = $$v
      },
      expression: "v100"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 50"
    },
    model: {
      value: (_vm.v50),
      callback: function($$v) {
        _vm.v50 = $$v
      },
      expression: "v50"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 20"
    },
    model: {
      value: (_vm.v20),
      callback: function($$v) {
        _vm.v20 = $$v
      },
      expression: "v20"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 10"
    },
    model: {
      value: (_vm.v10),
      callback: function($$v) {
        _vm.v10 = $$v
      },
      expression: "v10"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 5"
    },
    model: {
      value: (_vm.v5),
      callback: function($$v) {
        _vm.v5 = $$v
      },
      expression: "v5"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 1"
    },
    model: {
      value: (_vm.v1),
      callback: function($$v) {
        _vm.v1 = $$v
      },
      expression: "v1"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Monedas de 1"
    },
    model: {
      value: (_vm.m1),
      callback: function($$v) {
        _vm.m1 = $$v
      },
      expression: "m1"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Monedas de 0.50"
    },
    model: {
      value: (_vm.v050),
      callback: function($$v) {
        _vm.v050 = $$v
      },
      expression: "v050"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Monedas de 0.25"
    },
    model: {
      value: (_vm.v025),
      callback: function($$v) {
        _vm.v025 = $$v
      },
      expression: "v025"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Monedas de 0.10"
    },
    model: {
      value: (_vm.v010),
      callback: function($$v) {
        _vm.v010 = $$v
      },
      expression: "v010"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Monedas de 0.05"
    },
    model: {
      value: (_vm.v005),
      callback: function($$v) {
        _vm.v005 = $$v
      },
      expression: "v005"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Recibo"
    },
    model: {
      value: (_vm.recibo),
      callback: function($$v) {
        _vm.recibo = $$v
      },
      expression: "recibo"
    }
  })], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "No. Boleta 1"
    },
    model: {
      value: (_vm.boleta_n1),
      callback: function($$v) {
        _vm.boleta_n1 = $$v
      },
      expression: "boleta_n1"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Boleta 1"
    },
    model: {
      value: (_vm.boleta1),
      callback: function($$v) {
        _vm.boleta1 = $$v
      },
      expression: "boleta1"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.bancos,
      "itemText": "nombre",
      "label": "banco",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.banco),
      callback: function($$v) {
        _vm.banco = $$v
      },
      expression: "banco"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "No. Boleta 2"
    },
    model: {
      value: (_vm.boleta_n2),
      callback: function($$v) {
        _vm.boleta_n2 = $$v
      },
      expression: "boleta_n2"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Boleta 2"
    },
    model: {
      value: (_vm.boleta2),
      callback: function($$v) {
        _vm.boleta2 = $$v
      },
      expression: "boleta2"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.bancos,
      "itemText": "nombre",
      "label": "banco2",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.banco2),
      callback: function($$v) {
        _vm.banco2 = $$v
      },
      expression: "banco2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "No. Boleta 3"
    },
    model: {
      value: (_vm.boleta_n3),
      callback: function($$v) {
        _vm.boleta_n3 = $$v
      },
      expression: "boleta_n3"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Boleta 3"
    },
    model: {
      value: (_vm.boleta3),
      callback: function($$v) {
        _vm.boleta3 = $$v
      },
      expression: "boleta3"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.bancos,
      "itemText": "nombre",
      "label": "banco3",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.banco3),
      callback: function($$v) {
        _vm.banco3 = $$v
      },
      expression: "banco3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Suma Total",
      "disabled": ""
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Total a Entregar",
      "disabled": ""
    },
    model: {
      value: (_vm.caja.total),
      callback: function($$v) {
        _vm.$set(_vm.caja, "total", $$v)
      },
      expression: "caja.total"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Diferencia",
      "disabled": ""
    },
    model: {
      value: (_vm.diferencia),
      callback: function($$v) {
        _vm.diferencia = $$v
      },
      expression: "diferencia"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "blue--text text--darken-2",
    attrs: {
      "disabled": _vm.cuadrado
    },
    on: {
      "click": _vm.editarcaja
    }
  }, [_vm._v("\n                  Guardar\n      ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47cda9ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cuadrar.vue
// module id = 434
// module chunks = 1